
export class Loader{

    public static loadJs(url:string):void{
        var script:HTMLScriptElement = document.createElement("SCRIPT") as HTMLScriptElement;
        script.src  = url;
        script.type = 'text/javascript';
        document.getElementsByTagName("head")[0].appendChild(script);
    }

    public static loadCss(url:string):void{
        var script:HTMLLinkElement = document.createElement("link") as HTMLLinkElement;
        script.href = url;
        script.type = 'text/css';
        script.rel  = 'stylesheet';
        document.getElementsByTagName("head")[0].appendChild(script);
    }
}

